import React from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import { Button, Card, Container } from "react-bootstrap";

const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center min-vh-100 bg-light"
    >
      <Card className="text-center shadow-lg" style={{ width: "25rem" }}>
        <Card.Body>
          <Card.Title className="text-danger display-4">
            Oops! Qualcosa è andato storto 😔
          </Card.Title>
          <Card.Text className="text-muted mb-4">
            Errore: {error.statusText || error.message || "Errore sconosciuto."}
          </Card.Text>
          <Button
            variant="danger"
            size="lg"
            onClick={() => navigate("/")}
            className="px-5 py-2"
          >
            Torna alla Home
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ErrorPage;
